'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fadt';
var iconName = 'suitcase';
var width = 512;
var height = 512;
var aliases = [129523];
var unicode = 'f0f2';
var svgPathData = ['M16 160l0 256c0 26.5 21.5 48 48 48l48 0 0-352-48 0c-26.5 0-48 21.5-48 48zm112-48l0 352 256 0 0-352-256 0zm272 0l0 352 48 0c26.5 0 48-21.5 48-48l0-256c0-26.5-21.5-48-48-48l-48 0z', 'M200 16l112 0c13.3 0 24 10.7 24 24l0 56-160 0 0-56c0-13.3 10.7-24 24-24zM160 40l0 56-96 0C28.7 96 0 124.7 0 160L0 416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-256c0-35.3-28.7-64-64-64l-96 0 0-56c0-22.1-17.9-40-40-40L200 0c-22.1 0-40 17.9-40 40zm8 72l216 0 0 352-256 0 0-352 40 0zm-56 0l0 352-48 0c-26.5 0-48-21.5-48-48l0-256c0-26.5 21.5-48 48-48l48 0zM400 464l0-352 48 0c26.5 0 48 21.5 48 48l0 256c0 26.5-21.5 48-48 48l-48 0z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faSuitcase = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;